// import { useNavigate } from "react-router-dom";
// import CustomIcon from "../../components/CustomIcon";
// import Typography from "@mui/material/Typography";
// import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
// import FolderOpenIcon from "@mui/icons-material/FolderOpen";
// import React from "react";

// const CardGrid = () => {
//   const navigate = useNavigate();

//   const cards = [
//     {
//       title: "Collection Kit Registration",
//       desc: "Have kits assembled and ready to enter into the system? Great! Click the button below to add a new collection kit.",
//       icon: "collection-kits",
//       actions: [
//         { label: "Register New Kit", to: "/collection-kits/new-kit", primary: true },
//         { label: "View Collection Kits", to: "/dashboard/collection-kits" },
//       ],
//     },
//     {
//       title: "Participant Scheduling",
//       desc: "Ready to add new participants to the schedule?",
//       icon: "patient-scheduling",
//       actions: [
//         {
//           label: "Schedule Participant",
//           to: "/verify-patient",
//           primary: true,
//           state: {
//             flow: "schedule",
//             returnTo: "/dashboard/patient-schedule",
//           },
//         },
//         { label: "View Schedule", to: "/dashboard/patient-schedule" },
//       ],
//     },
//     {
//       title: "Participant Check-In",
//       desc: "Ready to begin checking in participants for the day?",
//       icon: "patient-checkin",
//       actions: [
//         { label: "Participant Check-In", to: "/dashboard/patient-checkin", primary: true },
//         {
//           label: "Drop-In Participant",
//           to: "/verify-patient",
//           state: {
//             flow: "dropIn",
//             returnTo: "/dashboard/patient-checkin",
//           },
//         },
//       ],
//     },
//       {
//       // title: "BioSpecimen Data",
//       title: "Sample Collection",
//       desc: "Ready to collect a new sample or view the Sample Log?",
//       icon: "collection-kits",
//       actions: [
//         { label: "Collect New Sample", to: "/dashboard/biospecimendata", primary: true },
//         { label: "View Mitra Follow-Up", to: "/dashboard/biospecimendata" },
//       ],
//     },
//     {
//       title: "Sample Processing",
//       desc: "Ready to process new Aliquot samples or view the Sample log?",
//       icon: "bio-bank",
//       actions: [
//         { label: "Process Sample", to: "/dashboard/aliquot-data", primary: true },
//         // { label: "View Sample Log", to: "/dashboard/aliquot-data" },
//       ],
//     },

//       {
//       // title: "Sample Allocation",
//       title: "Aliquot Management",
//       desc: "Ready to check-in or check-out a sample for research?",
//       icon: "micro-sample",
//       actions: [
//         { label: "Check-In", to: "/dashboard/sample-checkinout?tab=check-in", primary: true },
//         { label: "Check-Out", to: "/dashboard/sample-checkinout?tab=check-out" },
//         { label: "History", to: "/dashboard/sample-checkinout?tab=checkout-history" },
//         { label: "Usage-History", to: "/dashboard/sample-checkinout?tab=usage-history"},
//       ],
//     },
//     // {
//     //   title: "Follow-Up Management",
//     //   desc: "View participant email history and templates.",
//     //   icon: "reports",
//     //   actions: [
//     //     { label: "Open Email Center", to: "/dashboard/emails", primary: true },
//     //   ],
//     // },
//     // {
//     //   title: "Project Management",
//     //   desc: "Create and manage projects",
//     //   icon: "reports",
//     //   actions: [
//     //     { label: "Manage", to: "/dashboard/project-management", primary: true },
//     //     { label: "Create Project", to: "/add-project", primary: true },

//     //   ],
//     // },
//     {
//   title: "Follow-Up Management",
//   desc: "View participant email history and templates.",
//   icon: AssignmentTurnedInIcon,
//   {action.primary && <CustomIcon name={icon} viewBox="0 0 20 20" />}
//   actions: [
//     { label: "Open Email Center", to: "/dashboard/emails", primary: true },
//   ],
// },
// {
//   title: "Project Management",
//   desc: "Create and manage projects",
//   icon: FolderOpenIcon,
//   actions: [
//     { label: "Manage", to: "/dashboard/project-management", primary: true },
//     { label: "Create Project", to: "/add-project", primary: true },
//   ],
// },
//         {
//       // title
//       title: "Email Center",
//       desc: "View participant email history and templates.",
//       icon: "reports",
//       actions: [
//         { label: "Messages", to: "/dashboard/emails", primary: true },
//         { label: "Templates", to: "/dashboard/emails?tab=templates", primary: true },
//       ],
//     },
//   ];

//   const handleActionClick = (action) => {
//     navigate(action.to, action.state ? { state: action.state } : undefined);
//   };

//   return (
//     <div className="card-grid">
//       {cards.map((card) => (
//         <DashboardCard
//           key={card.title}
//           {...card}
//           onActionClick={handleActionClick}
//         />
//       ))}
//     </div>
//   );
// };

// const DashboardCard = ({ title, desc, icon, actions, onActionClick }) => (
//   <div className="dashboard-card">
//     <div className="card-header">
//       <h2 className="card-title">{title}</h2>
//     </div>
//     <p className="card-desc">{desc}</p>
//     <div className="button-group">
//       {actions.map((action) => (
//         <button
//           key={action.label}
//           type="button"
//           className={`card-button${action.primary ? "" : " secondary"}`}
//           onClick={() => onActionClick(action)}
//         >
//           {action.primary && <CustomIcon name={icon} viewBox="0 0 20 20" />}
//           <Typography
//             component="span"
//             sx={{ marginLeft: action.primary ? 1 : 0 }}
//             color={action.primary ? "white" : "inherit"}
//           >
//             {action.label}
//           </Typography>
//         </button>
//       ))}
//     </div>
//   </div>
// );

// export default CardGrid;

import Box from "@mui/material/Box";
import React from "react";
import SampleTypeManagementCard from "../../admin/components/SampleTypeManagementCard";
import KitTypeManagementCard from "../../admin/components/KitTypeManagementCard";

const CardGrid = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <Box sx={{ width: "100%" }} data-tour-id="dashboard-sample-types">
        <SampleTypeManagementCard />
      </Box>
      <Box sx={{ width: "100%" }} data-tour-id="dashboard-kit-types">
        <KitTypeManagementCard />
      </Box>
    </Box>
  );
};

export default CardGrid;
